import { axiosInstance } from "../../../Utils/AxiosInstance";

export const GetWorkOrderByIdAction = (data) => ({
  type: "get_workorder_byid",
  data,
  loader: false,
});

export function getWorkOrderById(id) {
  return async (dispatch) => {
    dispatch({ type: "get_workorder_byid", data: null, loader: true });
    try {
      const res = await axiosInstance.get(`/WorkOrders/GetById/${id}`);
      dispatch(GetWorkOrderByIdAction(res.data));
      return res;
    } catch (error) {
      dispatch(GetWorkOrderByIdAction(null));
      return { ...error?.response };
    }
  };
}
